import React from 'react';
import clsx from 'clsx';
import { is } from '../../../services/classify';
import { Icon, IconColor, IconSize } from '../../icon';
import { useTrilogyContext } from '../../../context';
import { hashClass } from '../../../helpers';
/**
 * Timeline Marker Component
 * @param className {string} Additionnal CSS Classes
 * @param iconClassname {string} Additionnal CSS Classes for icon
 * @param iconName {IconName} Icon Name - sample : IconName.ENVELOPE
 * @param iconColor {IconColor} Icon Color
 * @param children {ReactNode}
 */
const TimelineMarker = ({ className, iconClassname, iconName, iconColor, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('timeline-marker', is('icon'), className));
    const iconClasses = clsx(iconClassname);
    return (React.createElement("div", { className: classes, ...others, "data-testid": testId },
        React.createElement("div", { className: 'card-header-icon' },
            React.createElement(Icon, { color: iconColor || IconColor.WHITE, className: iconClasses, name: iconName, size: IconSize.SMALL }))));
};
export default TimelineMarker;
//# sourceMappingURL=TimelineMarker.js.map